<template>
  <div>
    <van-row class="m-t-075">
      <van-col :span="24" class="text-r" @click="closeAppontLiveOver">
        <van-icon name="cross" class="m-r-075" />
      </van-col>
      <van-col :span="24" class="text-c" style="font-size: 1rem">
        绑定昵称
      </van-col>
      <van-col :span="20" :offset="2" class="text-c f-s-16 m-t-10 fontSize">
        进入直播间，为了与老师和同学互动交流，请绑定您的社交账号
      </van-col>
      <van-col
        :span="QQLoginType != null ? 24 : 12"
        class="text-c m-t-11"
        @click="wechat"
        v-if="browserType == 'wx' && wxLoginType == null"
      >
        <img src="../../assets/imgs/wx.png" alt="WeChat" class="imgStyle" />
        <p class="fontSize">微信</p>
      </van-col>
      <!-- @click="QQBind" -->
      <van-col
        :span="browserType != 'wx' || wxLoginType != null ? 24 : 12"
        class="text-c m-t-11"
        v-if="QQLoginType == null"
        @click="QQBind"
      >
        <img :src="QQLoginPng" alt="WeChat" class="imgStyle" />
        <p class="fontSize">QQ</p>
      </van-col>
    </van-row>
  </div>
</template>
<script>
/* eslint-disable */
import { browserType } from "@/utils/commonUtils";

export default {
  // components: { button },
  props: {
    closeBinding: Function,
  },
  created() {
    this.getCode();
    this.browserType = browserType();
  },
  data() {
    return {
      wxLogin: {
        appid: this.GLOBAL.wxLogin.appid,
        scope: this.GLOBAL.wxLogin.scope, // snsapi_userinfo    ||    snsapi_login
        self_redirect: this.GLOBAL.wxLogin.self_redirect,
        redirect_uri: this.GLOBAL.wxLogin.redirect_uri,
        response_type: this.GLOBAL.wxLogin.response_type,
        state: this.GLOBAL.wxLogin.scstateope,
        code: this.GLOBAL.wxLogin.code,
        secret: this.GLOBAL.wxLogin.secret,
      },
      browserType: "",
      QQLogin: {
        appid: this.GLOBAL.QQBing.appid,
        appKey: this.GLOBAL.QQBing.appKey,
        redirectURI: this.GLOBAL.QQBing.redirectURI,
      },
      QQLoginPng: require("@/assets/imgs/login/Qq.png"),
    };
  },
  methods: {
    // 绑定QQ接口
    QQBind() {
      let QQappid = this.GLOBAL.QQBing.appid;
      let redirectURI = this.GLOBAL.QQBing.redirectURI;
      QC.Login.showPopup({
        appId: QQappid,
        redirectURI: redirectURI, //登录成功后会自动跳往该地址
      });
    },
    closeAppontLiveOver() {
      this.$emit("closeBinding");
    },
    // 获取微信返回的code
    getCode() {
      if (this.$route.query.code == undefined) {
        return false;
      }
      this.wxLogin.code = this.$route.query.code;
      if(this.$route.query.code != undefined){
      let data = { code: this.wxLogin.code, uid: localStorage.getItem("uid") };
      this.Api({
        url: "api/getaccess_tokenBycode",
        method: "POST",
        data,
      })
        .then((res) => {
          this.$toast("微信授权登录");
          this.detectBind(res.data);
          console.log(res);
        })
        .catch((err) => {
          console.log(err);
        });
      }else if( this.$route.query.openId != undefined){
        let data = {
          qqOpenid:this.$route.query.openId,
          accessToken:this.$route.query.accessToken,
          uid:localStorage.getItem("uid")
        }
        this.Api({
          url:'api/qq/get_access_token',
          method:"POST",
          data
        }).then(res => {
            this.$toast('QQ授权登录成功')
            this.detectBind(res.data)
        }).catch(err => {
          alert("QQ授权登录失败,请联系学习规划老师")
          console.log(err + "QQ授权登录失败")
        })
      }
    },


    detectBind(data) {
      this.$store.commit("Login/editPersonalInfo", data);
      localStorage.setItem("uid", data.uid);
      if (data.qqOpenid != null) {
        this.$store.commit("Login/editQqBingType", true);
        localStorage.setItem("qqOpenidType", data.qqOpenid);
      }
      if (data.wxOpenid != null) {
        this.$store.commit("Login/editWxBingType", true);
        localStorage.setItem("wxOpenidType", data.wxOpenid);
      }
    },
    // 调用微信登录
    wechat() {
      let wxLogin = this.GLOBAL.wxLogin;
      // https://open.weixin.qq.com/connect/qrconnect?appid=APPID&redirect_uri=REDIRECT_URI&response_type=code&scope=SCOPE&state=STATE#wechat_redirect
      window.location.href =
        "https://open.weixin.qq.com/connect/oauth2/authorize?appid=" +
        wxLogin.appid +
        "&redirect_uri=" +
        window.location +
        "&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect";
    },
  },
  computed: {
    QQLoginType() {
      // QQ绑定的状态
      return localStorage.getItem("qqOpenidType");
    },
    wxLoginType() {
      // 微信绑定的状态
      return localStorage.getItem("wxOpenidType");
    },
  },
};
</script>

<style lang="less" scoped>
.imgStyle {
  width: 2.9rem;
  height: 2.9rem;
}
.fontSize {
  color: #6b7686;
  font-size: 0.7rem;
}
</style>
